import * as React from 'react';
import { useCallback } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import cn from 'classnames';
import Checkbox from '../../../BaseComponents/Checkbox';
import { useTheme } from '../../../theme';
import { useToggleable } from '../../../hooks';
import { SubsidyType } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import CdnImage from '../../../CdnImage';
const SubsidiesSelector = props => {
    var _a, _b;
    const { SubsidiesSelector: theme } = useTheme('Subsidies');
    const { setOpen: setActive, isOpen: isActive } = useToggleable(false);
    const { t } = useTranslation('Subsidies');
    const handleChange = useCallback((e) => {
        props.onChange(e);
        setActive(e.target.checked);
    }, [props.onChange]);
    const subsidyKey = `${props.type}${props.type === SubsidyType.Other ? `_${props.id}` : ''}`;
    const title = t(`program_${subsidyKey}`);
    const description = t(`description_${subsidyKey}`);
    return (React.createElement(FormGroup, { className: cn(theme.container, {
            [theme.active]: props.isSelected,
            [theme.disabled]: props.disabled
        }, props.className) }, (_b = (_a = props.content) === null || _a === void 0 ? void 0 : _a.call(props, {
        isActive,
        icon: React.createElement(CdnImage, { path: `Subsidy/${subsidyKey}.svg` }),
        disabled: props.disabled,
        type: props.type,
        title: title,
        onChange: handleChange
    })) !== null && _b !== void 0 ? _b : (React.createElement(FormControlLabel, { disabled: props.disabled, className: theme.label, classes: { label: theme.label }, control: React.createElement(Checkbox, { className: theme.checkbox, checked: props.isSelected, onChange: handleChange }), label: React.createElement("div", { className: theme.subsidyInfo },
            React.createElement("span", { className: theme.text },
                React.createElement("div", { className: theme.title }, title),
                React.createElement("div", { className: theme.description }, description)),
            React.createElement(CdnImage, { path: `Subsidy/${subsidyKey}.svg` })) }))));
};
export default SubsidiesSelector;
